import React, { AriaRole } from 'react';
import { useSelector } from 'react-redux';
import { IconDeviceSettingsOutline, IconDeviceSettingsFill } from '@saucelabs/ds-icons';

import * as globalSelectors from '../../../selectors';
import selectors from '../selectors';
import { useIsWebRtcSupported } from '../hooks/useIsWebRtcSupported';
import GenericPopover from './GenericPopover';
import GenericButton from './GenericButton';
import ButtonLanguage from './ButtonLanguage';
import ButtonWifi from './ButtonWifi';
import ButtonAnimations from './ButtonAnimations';
import ButtonAccessibilityAudio from './ButtonAccessibilityAudio';
import ButtonAudio from './ButtonAudio';
import ButtonPerformanceMode from './ButtonPerformanceMode';

const DeviceSettingsButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const { deviceToolsDisabled } = useSelector(selectors.toolbarButtonSelector);
  const isWebRtcEnabled = useIsWebRtcSupported();
  const {
    changeLocaleSupported,
    isMuteSupported,
    toggleSystemAnimationsSupported,
    toggleWifiSupported,
  } = useSelector(globalSelectors.mobileSessionSelector);

  return (
    <GenericPopover
      trigger={(
        <GenericButton
          dataQa="live-session-toolbar-device-settings-group-button"
          disabled={deviceToolsDisabled}
          hasSubmenu
          icon={IconDeviceSettingsOutline}
          iconHightlight={IconDeviceSettingsFill}
          isPopoverTrigger
          label="Device Settings"
          role={role || 'menuitem'}
        />
      )}
    >
      <>
        {(isMuteSupported) && (
          <ButtonAccessibilityAudio role="menuitem" />
        )}

        {(isMuteSupported && isWebRtcEnabled) && (
          <ButtonAudio role="menuitem" />
        )}

        {isWebRtcEnabled && (
          <ButtonPerformanceMode role="menuitem" />
        )}

        {toggleWifiSupported && (
          <ButtonWifi role="menuitem" />
        )}

        {changeLocaleSupported && (
          <ButtonLanguage role="menuitem" />
        )}

        {toggleSystemAnimationsSupported && (
          <ButtonAnimations role="menuitem" />
        )}
      </>
    </GenericPopover>
  );
};

DeviceSettingsButton.displayName = 'DeviceSettingsButton';

export default DeviceSettingsButton;
